import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id BA71CE05-DEA6-4638-AF5C-2194D6FB946E
 * name toy-brick-minus-outline
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toy-brick-minus-outline.svg
 * tags
 */
export const ToyBrickMinusOutlineIcon = createSvgIcon(<><path d="M13.09 20H3V6H5V5C5 3.9 5.9 3 7 3H9C10.11 3 11 3.9 11 5V6H13V5C13 3.9 13.9 3 15 3H17C18.11 3 19 3.9 19 5V6H21V13.35C20.37 13.13 19.7 13 19 13V8H5V18H13.09C13.04 18.33 13 18.66 13 19S13.04 19.67 13.09 20M23 18H15V20H23V18Z" /></>, 'ToyBrickMinusOutlineIcon');
export default ToyBrickMinusOutlineIcon